export default "__VITE_ASSET__BlLKqfNy__"